import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {MaterialModule} from '../material/material.module';
import { DirectorySearchComponent } from './components/directory-search/directory-search.component';
import { ProfileSummaryComponent } from './components/profile-summary/profile-summary.component';
import {NgSelectModule} from '@ng-select/ng-select';
import { FlexLayoutModule } from '@angular/flex-layout';
import { LoadingOverlayComponent } from './components/loading-overlay/loading-overlay.component';
import {TimeagoModule} from 'ngx-timeago';
import {ActiveFiltersComponent} from './components/active-filters/active-filters.component';

@NgModule({
  imports: [
    CommonModule,
    MaterialModule,
    NgSelectModule,
    FlexLayoutModule,
    TimeagoModule.forRoot()
  ],
  declarations: [
    DirectorySearchComponent,
    LoadingOverlayComponent,
    ProfileSummaryComponent,
    ActiveFiltersComponent
  ],
  exports: [
    DirectorySearchComponent,
    LoadingOverlayComponent,
    ProfileSummaryComponent,
    TimeagoModule,
    ActiveFiltersComponent
  ]
})

export class CoModule { }
